
  import React from "react"
  import Component from "/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/src/layouts/index.js"
  import data from "/mnt/c/Users/pranas.ORADEV/Documents/projects/lights-out/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js